package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import dev.lingvo.shared.screenshots.doc.TemplateId
import dev.lingvo.shared.screenshots.templates.Template
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LCard
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.LSectionHeading
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t

/** Live samples sit inside real cards, keeping template selection keyboard reachable. */
@Composable
internal fun LayoutPicker(
    layouts: List<Template>, selected: TemplateId?, canWrite: Boolean,
    onSelect: (Template) -> Unit, preview: @Composable (Template) -> Unit,
) {
    Column(Modifier.fillMaxWidth().gap(Space.MD)) {
        LSectionHeading(if (selected == null) t("app.projects.slug.screenshots.layout_picker.start", "Start from a layout")
            else t("app.projects.slug.screenshots.layout_picker.layout", "Layout"), description = t("app.projects.slug.screenshots.layout_picker.description", "Pick how the caption and capture compose."))
        Row(Modifier.fillMaxWidth().gap(Space.MD).styleModifier { property("flex-wrap", "wrap") }) {
            layouts.forEach { layout ->
                LCard(Modifier.styleModifier { property("flex", "1 1 160px"); property("min-width", "0") }) {
                    Column(Modifier.gap(Space.SM)) {
                        preview(layout)
                        LMuted(layout.displayName)
                        if (canWrite) LButton(layout.displayName, variant = LButtonVariant.SECONDARY,
                            onClick = { onSelect(layout) }, modifier = Modifier.fillMaxWidth().attr("aria-pressed", (selected == layout.id).toString()).styleModifier {
                                property("outline", if (selected == layout.id) "2px solid currentColor" else "none")
                            })
                    }
                }
            }
        }
    }
}
